module.exports = __webpack_public_path__ + "static/media/sykkel_gul-min.46a9c614.png";